'use client';

import { AnalyticsContext } from '@carvana/eventable-clickstream';
import {
  DetailedHTMLProps,
  ElementType,
  HTMLAttributes,
  useContext,
  useEffect,
  useRef
} from 'react';
import { CommonSection } from './financing-rsc.styles';

type SectionProps = DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement>;

export type OwnProps = SectionProps & {
  as?: ElementType;
  eventName: string;
};

export default function Section({
  eventName,
  as: Component = CommonSection,
  ...props
}: OwnProps) {
  const { trackEvent } = useContext(AnalyticsContext);

  const sectionRef = useRef<HTMLElement>(null);
  const hasTrackedRef = useRef(false);

  useEffect(() => {
    if (!sectionRef.current || !eventName) {
      return;
    }

    const element = sectionRef.current;

    hasTrackedRef.current = false;

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !hasTrackedRef.current) {
            trackEvent(eventName, { action: 'viewed' });
            hasTrackedRef.current = true;
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -10% 0px'
      }
    );

    observer.observe(element);

    return () => {
      observer.unobserve(element);
      observer.disconnect();
    };
  }, [eventName, trackEvent]);

  return <Component {...props} ref={sectionRef} />;
}
